import {_get, clubId} from "@api/doinsport/services/httpService";
import {STRIPE_URL} from "@api/doinsport/services/stripe";

const PAYOUT_URL = `${STRIPE_URL}/payouts`;

export const getPayouts = (page = 1, itemsPerPage = 10, filters = '') => _get(`${PAYOUT_URL}?account.club.id=${clubId}&page=${page}&itemsPerPage=${itemsPerPage}${filters}`);

export const getPayoutReport = (payoutId) => _get(`${PAYOUT_URL}/${payoutId}/report-run.csv`);
